var _defs, _path, _path2, _rect, _rect2, _rect3, _circle, _circle2, _rect4, _rect5, _rect6, _polygon, _polygon2, _path3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path4, _path5, _path6, _path7, _path8, _rect13, _path9, _path10, _rect14, _rect15, _rect16, _rect17, _rect18, _circle3, _circle4, _circle5, _circle6, _path11, _rect19, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle7, _path27, _path28, _ellipse, _path29, _path30, _path31, _path32, _path33, _ellipse2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle8, _path49, _rect20, _path50, _rect21, _rect22, _path51, _rect23, _path52, _rect24, _rect25, _rect26, _path53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "afcf7ba7-9a9d-4a96-99b1-c6a86c14369d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1124.67665,
    height: 770.76802,
    viewBox: "0 0 1124.67665 770.76802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f93e83ed-aae3-4939-a31b-02dcc6721011",
    x1: 969.1404,
    y1: 556.31063,
    x2: 969.1404,
    y2: 137.11639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e0229f75-5a20-4c1d-bfcf-9b57e2e8c95e",
    x1: 355.66372,
    y1: 691.67079,
    x2: 355.66372,
    y2: 298.97832,
    xlinkHref: "#f93e83ed-aae3-4939-a31b-02dcc6721011"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Firmware") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1098.47347,502.76777c-37.663,47.88386-23.031,117.83664.9016,173.85981,8.01293,18.75725,17.0759,38.60234,13.695,58.71728-4.13432,24.59753-26.08748,42.58378-49.13665,52.1162-42.01754,17.37713-92.2982,13.2358-130.90628-10.782-33.36454-20.75585-57.25858-54.5096-91.19252-74.32082-56.78845-33.15408-129.07155-20.634-190.73642,2.2038-43.62646,16.15721-91.32258,37.16931-134.67243,20.284-30.50319-11.88137-51.58771-40.79984-63.076-71.45325-5.5467-14.79989-9.57255-30.81931-20.1645-42.55018-6.297-6.9741-14.51488-11.92428-22.93319-16.09827C333.38059,556.62972,236.292,577.04065,161.627,534.76664c-50.4261-28.55036-82.70874-82.406-97.00245-138.563S51.99574,281.16217,55.62485,223.3284c2.579-41.1,7.20632-84.97836,33.46752-116.69913,27.78074-33.55622,75.45828-46.03383,118.55249-39.65584S289.80028,96.0835,324.16473,122.858c42.94814,33.46235,82.77835,75.131,135.50913,88.6859,35.91013,9.231,73.68546,4.18165,110.72181,2.43307,61.91628-2.92324,123.858,3.57752,185.43319,10.69583,58.94744,6.81455,118.32064,14.31464,174.47711,33.49047,39.74036,13.57022,71.60046,38.20328,109.12549,55.4123,24.46028,11.21751,51.13328,14.31495,74.29231,28.60252,28.52845,17.60014,54.68268,48.213,47.37314,84.0348C1154.14731,460.27072,1118.46334,477.35311,1098.47347,502.76777Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f9224b",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M772.70649,212.225s-60.54073-17.93019-64.54073,33.06981,16,135,0,162-73.09311,66.00953-43.04656,69.50476,45.04656,8.49524,36.04656,26.49524-56,35-46,48,15,29,5,45-45,26-39,37,28,17,17,29-42.88811,39.29611-30.444,39.14806",
    transform: "translate(-37.66167 -65.36599)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 682.84211,
    y: 112.88104,
    width: 153.61197,
    height: 71.24033,
    rx: 12.9697,
    fill: "#f9224b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 695.08655,
    y: 173.18753,
    width: 129.1231,
    height: 1.33576,
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 695.08655,
    y: 124.01234,
    width: 129.1231,
    height: 48.97773,
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 725.14106,
    cy: 149.52335,
    r: 17.81008,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 794.15514,
    cy: 149.52335,
    r: 17.81008,
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 746.28967,
    y: 184.11937,
    width: 26.71374,
    height: 15.58769,
    fill: "#f9224b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 703.99159,
    y: 195.25268,
    width: 111.31302,
    height: 89.05042,
    fill: "#f9224b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 701.76533,
    y: 302.11318,
    width: 115.76554,
    height: 11.1313,
    fill: "#f9224b"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "720.689 339.96 720.689 353.317 720.689 373.353 720.689 384.485 720.689 391.164 740.725 391.164 740.725 384.485 740.725 373.353 740.725 353.317 740.725 339.96 740.725 324.376 720.689 324.376 720.689 339.96",
    fill: "#f9224b"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "780.798 324.376 780.798 339.96 780.798 353.317 780.798 373.353 780.798 384.485 780.798 391.164 800.834 391.164 800.834 384.485 800.834 373.353 800.834 353.317 800.834 339.96 800.834 324.376 780.798 324.376",
    fill: "#f9224b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M726.49153,280.65563v20.59108a30.11851,30.11851,0,0,0-14.80062,7.13458A35.01353,35.01353,0,0,0,702.88,321.30117a65.63157,65.63157,0,0,0-4.339,19.72228,112.76591,112.76591,0,0,0,1.2317,26.45817h-22.2623a151.97079,151.97079,0,0,1,.5826-31.93176,84.74431,84.74431,0,0,1,7.14481-25.3083c6.44972-13.52806,15.62347-20.867,23.68306-24.8534A43.73973,43.73973,0,0,1,726.49153,280.65563Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f9224b"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 720.68854,
    y: 324.37578,
    width: 20.03634,
    height: 15.58382,
    opacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 720.68854,
    y: 353.31717,
    width: 20.03634,
    height: 20.03634,
    opacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 720.68854,
    y: 384.48481,
    width: 20.03634,
    height: 6.67878,
    opacity: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 780.79757,
    y: 324.37578,
    width: 20.03634,
    height: 15.58382,
    opacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 780.79757,
    y: 353.31717,
    width: 20.03634,
    height: 20.03634,
    opacity: 0.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 780.79757,
    y: 384.48481,
    width: 20.03634,
    height: 6.67878,
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M726.49153,280.65563v20.59108a30.11851,30.11851,0,0,0-14.80062,7.13458l-2.77-22.99313A43.73973,43.73973,0,0,1,726.49153,280.65563Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M702.88,321.30117a65.63157,65.63157,0,0,0-4.339,19.72228l-20.448-5.47359a84.74431,84.74431,0,0,1,7.14481-25.3083Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M868.128,280.65563v20.59108a30.11855,30.11855,0,0,1,14.80062,7.13458,35.01353,35.01353,0,0,1,8.81091,12.91988,65.63157,65.63157,0,0,1,4.339,19.72228,112.76591,112.76591,0,0,1-1.2317,26.45817h22.26229a151.97018,151.97018,0,0,0-.58259-31.93176,84.74431,84.74431,0,0,0-7.14481-25.3083c-6.44973-13.52806-15.62347-20.867-23.68306-24.8534A43.73977,43.73977,0,0,0,868.128,280.65563Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f9224b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M868.128,280.65563v20.59108a30.11855,30.11855,0,0,1,14.80062,7.13458l2.77-22.99313A43.73977,43.73977,0,0,0,868.128,280.65563Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M891.73955,321.30117a65.63157,65.63157,0,0,1,4.339,19.72228l20.448-5.47359a84.74431,84.74431,0,0,0-7.14481-25.3083Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 746.28967,
    y: 184.11937,
    width: 26.71374,
    height: 1.84496,
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M854.94437,276.48527V313.768a7.76813,7.76813,0,0,1-2.06983-5.2845V281.76465A7.75545,7.75545,0,0,1,854.94437,276.48527Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M742.04856,278.94352v27.90966a7.76037,7.76037,0,0,1-2.07495,4.7223V274.22122A7.76042,7.76042,0,0,1,742.04856,278.94352Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 709.55893,
    y: 284.30479,
    width: 100.18033,
    height: 1.31857,
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 707.33067,
    y: 313.2468,
    width: 48.97603,
    height: 1.02214,
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 760.76323,
    y: 313.2468,
    width: 48.97603,
    height: 1.02214,
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 712.79403,
    y: 46.95276,
    width: 7.66608,
    height: 65.92828,
    fill: "#f9224b"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 800.69841,
    y: 46.95276,
    width: 7.66608,
    height: 65.92828,
    fill: "#f9224b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.37153,
    cy: 47.46383,
    r: 8.68822,
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.37153,
    cy: 46.95276,
    r: 8.68822,
    fill: "#f9224b"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.78698,
    cy: 47.46383,
    r: 8.68822,
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.78698,
    cy: 46.95276,
    r: 8.68822,
    fill: "#f9224b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M661.66668,494.2905c-3.41787,3.42238-4.19751,8.12253-5.412,12.48071-3.4675,12.44329-11.63041,23.92156-23.00767,32.35222-8.33384,6.17546-19.50612,13.01306-17.53059,22.22695.47206,2.20169,1.71953,4.25648,2.04732,6.47678,1.41875,9.61007-13.27224,14.67361-18.95914,23.08309-4.2364,6.26454-3.10423,14.02542-1.84528,21.161,1.54091,8.7337,3.40507,18.0518,10.57068,24.48174,1.93329,1.7348,4.2379,3.24066,5.58688,5.33294,3.02253,4.688.39547,10.83231,3.143,15.63954,3.66382,6.4105,15.20266,6.68853,21.899,2.36614s9.79107-11.42845,12.75844-18.091c8.02019-18.0074,17.88023-36.0738,34.54914-49.18669,15.98194-12.57245,39.23137-22.32607,41.97365-40.62648,1.17584-7.84687-1.803-16.44618,2.74685-23.35942,2.15008-3.26694,5.74408-5.68777,8.17808-8.80939,7.2512-9.29973,1.85243-22.753-8.76461-29.35736C713.56938,480.49017,675.60983,480.329,661.66668,494.2905Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#dee3f3",
    opacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 871.66576,
    y: 170.7948,
    width: 74,
    height: 9,
    transform: "translate(-48.58986 213.60481) rotate(-17.35148)",
    fill: "#f9224b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M974.08652,494.31071s-38.72378-7.74476-49.05012-18.0711-56.79488-28.39744-61.958-15.48951-69.7028,56.79487-25.81585,64.53963,103.26341,10.32634,116.17134,5.16317S974.08652,494.31071,974.08652,494.31071Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#a8a8a8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M837.26249,520.49418c43.88694,7.74485,103.26337,10.3264,116.17132,5.1632,9.83009-3.932,16.66076-22.82408,19.36172-31.61589.8174.17386,1.291.26918,1.291.26918s-7.74474,30.979-20.65269,36.14219-72.28438,2.58165-116.17132-5.1632c-12.66842-2.23559-16.29128-7.48581-14.92655-14.13C823.4191,515.4947,827.8332,518.83022,837.26249,520.49418Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.08254,156.703a11.375,11.375,0,0,0-3.2046-4.44114c-10.38981-9.47074-27.19723-6.59983-40.09878-12.38494-2.97195-1.33265-6.02088-3.18145-9.24787-2.67488-4.50642.70742-8.69617,5.83763-12.62527,3.56146l.28131.857c-.09387-.046-.18775-.09216-.28131-.14638q1.44481,4.40089,2.88958,8.80175c1.10937,3.37913,2.279,6.85663,4.43669,9.67046a25.31872,25.31872,0,0,0,6.12286,42.11185c.13616.29453.27145.5904.403.88918.12223.05512.24849.10287.37174.15622a29.56234,29.56234,0,0,1,1.90686,6.131c-3.34387.46237-9.17346,4.16-14.908,9.62067l-11.46666-.39216a37.499,37.499,0,0,1-20.60173-7.00417L929.772,186.80748a11.47649,11.47649,0,0,0-6.57006,2.90392c-4.25788-4.43642-7.87134-9.07134-7.56366-11.78621,0,0-15.94574-29.84448-21.74419-14.92224S904.76618,193.558,904.76618,193.558l10.57535,13.70032a57.63458,57.63458,0,0,0-.79046,7.26188c13.04652,14.92224,58.70932,28.42332,58.70932,28.42332l7.12035.3447c.01451.13072.02716.24119.03972.34983a24.24391,24.24391,0,0,0-.63681,5.70071c.0042.27558.00915.56443.01411.853-.00213.18918-.017.37954-.01411.5682.3624,23.80453,3.624,96.63928,3.624,96.63928.63487-.2829,1.29-.54161,1.95725-.78535l-.50764,6.47s-30.44187,4.2635-52.91087,12.79049-23.1938,18.47516-23.1938,18.47516v87.78051c-6.41965,3.29364-16.54566,7.62246-21.74419,5.30586-5.64282-2.51458-8.74077-.40183-9.3007,1.80352h0v.00009a2.7998,2.7998,0,0,0-.02477,1.32571l.007.027a2.37642,2.37642,0,0,0,.21615.56256l.022.0415a2.2572,2.2572,0,0,0,.38262.5031c2.17442,2.13175,49.28684,20.60691,60.15893,17.76457a7.515,7.515,0,0,0,.98533-.33169c.10449-.04342.19753-.10054.29852-.1482.20124-.095.40456-.18732.59218-.29848.112-.0664.21235-.14624.31963-.21815.16266-.109.3286-.21408.4806-.33525.10587-.08445.20076-.181.30162-.27111.13967-.12478.28242-.24591.41271-.38106.095-.09854.18-.2077.27012-.31157.12307-.14182.24857-.28083.36275-.432.0822-.1089.15568-.22656.23341-.34.10953-.15982.22075-.31782.32166-.48636.06945-.1161.13139-.23945.1969-.35945.09746-.17847.1958-.3559.28468-.54248.05711-.12.1079-.24557.1616-.36869.08627-.1976.17249-.395.25022-.60021.04565-.12066.08609-.24561.12886-.36874.07579-.2178.15064-.436.21775-.66079.03472-.11662.06534-.2362.09781-.35455.066-.23993.13019-.4809.18722-.72733.02526-.10933.04733-.22054.07087-.331.056-.26231.10944-.52591.1562-.794.01721-.09893.03217-.19881.04818-.29843.0461-.28629.08892-.57384.12546-.86494.01044-.0834.01938-.16719.02907-.25094.03614-.31166.0683-.62437.09449-.93971.00544-.0658.01009-.13163.01508-.19756q.0387-.50508.06256-1.01278c.00208-.04528.00371-.09043.00562-.13571q.02269-.54282.03008-1.08531l.00071-.06848a59.50032,59.50032,0,0,0-1.39936-12.60408h0l2.63034-74.78366a407.78851,407.78851,0,0,0,42.65347-1.57114l1.55972,35.67912s0,23.44924,7.97287,34.108c6.82324,9.12182,14.7071,49.46454,16.83919,60.91076-2.92962,5.58517-8.53267,12.49184-18.2888,12.27929,0,0-18.35781-1.58711-17.32223,3.46231l.00213.0088a2.60307,2.60307,0,0,0,.11519.387l.0119.03287a3.58574,3.58574,0,0,0,.19912.42278l.01668.02828c.07308.13041.15868.26495.25393.40261.01942.0281.03831.05612.0587.08453.10684.14889.22368.30094.3571.45842l.03344.03769c.12215.14256.25778.28937.40244.439.03995.04138.08034.08288.12206.12482.16408.1649.33674.33248.52861.50609,9.42248,8.527,64.50776,9.94816,64.50776,9.94816l-.00008-.03283-.00009-.022-.00071-.10643-.00022-.03105c-.00044-.054-.0012-.12253-.00217-.19821l-.0004-.02914c-.03225-2.46662-.35975-15.41546-3.65946-25.16129h.76391s-7.97287-71.76889-14.49613-80.29588c0,0-1.73331-37.84271,2.1788-61.55963.24017-.08705.48322-.17249.72043-.26109,18.27247-6.82436,19.56928-23.63109,17.68724-35.97955,3.45667,1.11085,5.50656,1.87156,5.50656,1.87156s-.06326-.537-.18107-1.48747c.11551.042.18107.06631.18107.06631s-.34878-2.25648-.92207-5.77913c-1.30672-9.6826-3.83991-26.60383-6.53568-34.59256-.43536-1.75625-.85306-3.25721-1.23993-4.395a75.11839,75.11839,0,0,1-3.19128-14.76064,174.94331,174.94331,0,0,1-1.11986-19.57339,187.88465,187.88465,0,0,1,2.00352-26.11171c1.10677-7.55207,2.10293-16.14139,2.01883-22.13906a29.522,29.522,0,0,0-.436-6.23807c-.96794-4.4284-5.23919-7.3079-9.68106-9.14-.28609-.118-.57917-.215-.86814-.32463.10808-1.67852.2499-3.58037.43332-5.58565a4.77487,4.77487,0,0,0,3.69388.748c1.90939-.41809,3.27884-2.01161,4.49939-3.51063,6.42394-7.88975,13.02028-16.11371,15.4876-25.91476a55.99053,55.99053,0,0,0,1.35822-13.344q.00231-.36782,0-.73747A14.51225,14.51225,0,0,0,1060.08254,156.703Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "url(#f93e83ed-aae3-4939-a31b-02dcc6721011)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.59442,195.164s9.73254,14.59881,7.647,21.55062,22.941,2.78072,22.941,2.78072.69518-27.11206,5.56145-33.36869S1001.59442,195.164,1001.59442,195.164Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f7c4a7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M937.29016,204.549s-20.16025-16.68435-19.46507-22.941c0,0-15.294-29.19761-20.85544-14.5988S907.39737,196.902,907.39737,196.902l19.46507,25.7217Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f7c4a7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M916.78232,466.28467s-18.7699,11.81808-26.41689,8.34218-10.42772,2.08554-8.34217,4.17108,47.27232,20.16026,57.7,17.37953,5.12414-25.553,5.12414-25.553Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#535461"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.19322,517.0329s-4.51867,19.11748-20.16025,18.76989c0,0-23.63616-2.08554-14.5988,6.25663s61.87112,9.73254,61.87112,9.73254,0-28.50243-9.73254-34.75906S1016.19322,517.0329,1016.19322,517.0329Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#535461"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M987.6908,382.16775l2.08554,48.66268s0,22.941,7.647,33.3687,16.68435,62.5663,16.68435,62.5663h26.41688s-7.647-70.21329-13.90362-78.55547c0,0-2.78072-61.87112,6.95181-75.77475Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#575988"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M987.6908,382.16775l2.08554,48.66268s0,22.941,7.647,33.3687,16.68435,62.5663,16.68435,62.5663h26.41688s-7.647-70.21329-13.90362-78.55547c0,0-2.78072-61.87112,6.95181-75.77475Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.61011,338.37134s15.98917,38.235-13.20844,49.35786-82.03138,9.73254-82.03138,9.73254l-2.78073,80.641s-32.67351,4.17109-33.36869-6.25663v-88.288s.69518-9.73253,22.24579-18.07471,50.74823-12.51326,50.74823-12.51326l1.39036-18.07471Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#575988"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.991,212.41522a33.26594,33.26594,0,0,1,16.3338,2.30935c4.26032,1.79239,8.357,4.60949,9.28536,8.94187,1.09947,5.13087-.11957,16.63764-1.51811,26.37172a181.63475,181.63475,0,0,0-.84755,46.08522c.71678,6.38617,1.70524,11.95544,3.06084,14.44071,4.17109,7.647,8.34217,43.79641,8.34217,43.79641s-45.88195-17.37953-68.82293-6.95181c0,0-3.12832-71.25607-3.47591-94.54464-.26914-18.03255,22.59339-38.58255,30.24038-39.27774C1014.07026,213.17893,1012.53775,212.87731,1016.991,212.41522Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.991,211.02486a33.26582,33.26582,0,0,1,16.3338,2.30935c4.26032,1.79238,8.357,4.60949,9.28536,8.94187,1.09947,5.13087-.11957,16.63764-1.51811,26.37172a181.63475,181.63475,0,0,0-.84755,46.08522,74.75022,74.75022,0,0,0,3.06084,14.44071c3.12831,9.38494,8.34217,43.79641,8.34217,43.79641s-45.88195-17.37953-68.82293-6.95181c0,0-3.12832-71.25607-3.47591-94.54464-.26914-18.03255,22.59339-38.58256,30.24038-39.27774C1014.07026,211.78856,1012.53775,211.487,1016.991,211.02486Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#e14b5a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.40167,249.38815l-49.35787-2.78073s-3.14124-24.19841,3.98389-23.94986l48.84988,1.70406S1043.30529,236.87488,1029.40167,249.38815Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.40167,247.99778,973.092,245.21706s-43.79641-13.20844-56.30967-27.80725c0,0,.69518-25.7217,14.5988-27.11206l32.8869,24.11706a35.50711,35.50711,0,0,0,19.75967,6.85239l48.84988,1.70406S1043.30529,235.48452,1029.40167,247.99778Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#e14b5a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.8348,198.29233c.82629-6.59226,3.81552-8.77883,5.909-11.47049,4.86627-6.25663-36.14942,9.03735-36.14942,9.03735a73.74254,73.74254,0,0,1,5.54443,10.2286,24.92261,24.92261,0,0,0,10.44474,2.28467C1023.6307,208.37246,1027.50871,201.8626,1031.8348,198.29233Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.92191,
    cy: 117.28476,
    r: 25.02652,
    fill: "#f7c4a7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.77984,165.10891c-2.66536-2.91075-3.94626-6.794-5.15545-10.55095l-2.77151-8.611c3.76851,2.22684,7.787-2.79219,12.10925-3.48426,3.09509-.49559,6.01938,1.31315,8.86989,2.61691,12.3742,5.65972,28.49464,2.851,38.4598,12.11648a11.12289,11.12289,0,0,1,3.0736,4.34488,14.5372,14.5372,0,0,1,.558,4.90038,55.83429,55.83429,0,0,1-1.30271,13.05481c-2.36648,9.58862-8.6932,17.63432-14.8546,25.35307-1.17063,1.46651-2.48413,3.02553-4.31545,3.43452-3.57707.79887-6.345-3.06778-7.72944-6.46145a68.75306,68.75306,0,0,1-4.03335-13.952,18.28087,18.28087,0,0,0-1.65177-5.89664c-2.15408-3.81878-7.46391-7.43233-10.69262-10.39043C1009.1701,168.67583,1004.74487,168.34693,1001.77984,165.10891Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.77984,164.41373c-2.66536-2.91075-3.94626-6.794-5.15545-10.55095l-2.77151-8.611c3.76851,2.22684,7.787-2.79219,12.10925-3.48427,3.09509-.49558,6.01938,1.31316,8.86989,2.61692,12.3742,5.65972,28.49464,2.851,38.4598,12.11648a11.12289,11.12289,0,0,1,3.0736,4.34488,14.5372,14.5372,0,0,1,.558,4.90038,55.83429,55.83429,0,0,1-1.30271,13.05481c-2.36648,9.58862-8.6932,17.63432-14.8546,25.35306-1.17063,1.46652-2.48413,3.02553-4.31545,3.43453-3.57707.79887-6.345-3.06778-7.72944-6.46145a68.75324,68.75324,0,0,1-4.03335-13.952,18.28087,18.28087,0,0,0-1.65177-5.89664c-2.15408-3.81878-7.46391-7.43233-10.69262-10.39044C1009.1701,167.98065,1004.74487,167.65174,1001.77984,164.41373Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#632652"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 986.52613,
    cy: 120.06549,
    rx: 2.08554,
    ry: 4.51868,
    fill: "#f7c4a7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.70107,306.04541s-1.39036,4.17109-8.34218,3.47591-27.11206-2.08555-27.11206,0",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M981.43417,541.36424a5.88868,5.88868,0,0,1-2.02271-2.90063c-.18224.9033.376,2.07578,2.02271,3.59581,9.03735,8.34217,61.87112,9.73254,61.87112,9.73254s0-.246-.00781-.6954C1042.96385,551.08769,990.44279,549.67989,981.43417,541.36424Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#fff",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M939.72329,494.7871c-10.42771,2.78072-55.61449-15.294-57.7-17.37953a2.2571,2.2571,0,0,1-.57837-1.01629,2.49914,2.49914,0,0,0,.57837,2.40665c2.08554,2.08555,47.27232,20.16026,57.7,17.37953,5.36725-1.43126,6.56328-8.1573,6.46361-14.34986C946.08511,487.6023,944.69038,493.46255,939.72329,494.7871Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#fff",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M543.15947,548.06642A298.40742,298.40742,0,0,1,538.6829,507.017v-.00007a54.98956,54.98956,0,0,0-38.69748-50.21842c-3.949-1.21493-8.3042-2.35052-13.10626-3.37044-42.1284-8.94764-54.92591-1.13536-56.37994-.1083a54.0178,54.0178,0,0,1-3.18935-6.96572c-.07154-.24351-.13807-.49115-.20648-.7373a53.93276,53.93276,0,0,0,14.40969-32.49392c7.02685-7.12555,11.13238-15.722,11.13238-24.97765,0-7.96014-3.03952-15.43152-8.3594-21.90028V353.6836a54.70527,54.70527,0,0,0-54.70526-54.70528h-4.43643a54.70528,54.70528,0,0,0-54.70529,54.70528v13.5595a33.95949,33.95949,0,0,0-7.56325,20.90207c0,9.06125,3.9379,17.48925,10.69652,24.52533a53.94221,53.94221,0,0,0,15.0138,33.54527c.29593,2.05389.59968,4.26551.89923,6.59743L274.1127,468.75362s-29.05884,1.1942-47.768,39.80664c-15.83867,32.68828-47.36691,116.72511-56.669,141.74362l-.00005,0-.00007.00026c-1.68577,4.534-2.64281,7.13292-2.64281,7.13292s.30847-.31192.90053-.84494c-.58536,1.5814-.90053,2.4372-.90053,2.4372s.45755-.46245,1.32685-1.223c-1.32015,10.47017-1.50858,28.44058,12.2074,30.67994,11.49733,1.87712,41.112,2.64774,63.49158,2.96412v.02139h1.55214c14.83.199,26.11347.199,26.11347.199v-.199H512.35543V689.0057a16.58627,16.58627,0,0,0-1.326-6.518q.1734-.19987.33548-.40224a13.20763,13.20763,0,0,1,2.49679,5.78962,5.7963,5.7963,0,0,1-.113.61115s.04955-.12777.14178-.36836a6.19557,6.19557,0,0,1-.14178,1.96061s30.8728-79.5478,30.54283-127.04521A80.4727,80.4727,0,0,0,543.15947,548.06642ZM350.71985,463.5542a55.19235,55.19235,0,0,1-.76389-6.86021l.002-.06344C350.22377,458.86359,350.48083,461.18026,350.71985,463.5542Zm-93.525,170.86235V653.3751l-11.88441,2.53828Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "url(#e0229f75-5a20-4c1d-bfcf-9b57e2e8c95e)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M348.46564,241.26343h.00011A54.70528,54.70528,0,0,1,403.171,295.9687v23.3359a0,0,0,0,1,0,0H293.76036a0,0,0,0,1,0,0V295.9687A54.70528,54.70528,0,0,1,348.46564,241.26343Z",
    fill: "#e14b5a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 348.84825,
    cy: 326.95569,
    rx: 62.35643,
    ry: 42.84613,
    fill: "#e14b5a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M346.533,433.82887s13.00686,68.09475,0,86.45738,39.7857,25.63117,39.7857,25.63117L441.024,526.02457l7.65109-48.967s-33.28226-18.74518-26.39627-56.6181Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f7c4a7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M507.97106,663.36173s3.443,14.91964-15.30219,17.59752A106.0086,106.0086,0,0,1,459.313,680.562l-4.13453-37.47565h43.61124Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f7c4a7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M176.92322,644.26477s-8.27823,33.634,10.467,36.69448,87.605,3.06044,87.605,3.06044V644.234l-31.1723,6.65782-29.27135-28.08088Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f7c4a7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M350.54978,455.82577l-73.25924,15.49347s-27.9265,1.14767-45.90657,38.25548S174.38331,652.6502,174.38331,652.6502s33.28226-33.66482,72.30285,2.29533l26.01372-47.05424-5.73832,74.59818H468.56792v-35.195s42.081,22.57073,39.02059,35.195c0,0,36.00943-92.781,28.26476-134.948a286.77727,286.77727,0,0,1-4.30214-39.44983v-.00006A52.8467,52.8467,0,0,0,494.3616,459.83c-3.79512-1.16761-7.9806-2.25895-12.59554-3.23912-43.22869-9.18131-54.32277,0-54.32277,0s-8.3737,27.24644-8.22493,39.59442c.19128,15.876-22.57073,26.39628-22.57073,26.39628s-33.66482-8.03365-35.195-14.53708S347.87189,463.47687,350.54978,455.82577Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M350.54978,454.29555,277.29054,469.789S249.364,470.93669,231.384,508.0445,174.38331,651.12,174.38331,651.12s33.28226-33.66482,72.30285,2.29533l26.01372-47.05424-5.73832,74.59818H468.56792v-35.195s42.081,22.57074,39.02059,35.195c0,0,36.00943-92.781,28.26476-134.948a286.77727,286.77727,0,0,1-4.30214-39.44983v-.00006a52.8467,52.8467,0,0,0-37.18953-48.26153c-3.79512-1.16761-7.9806-2.25895-12.59554-3.23912-43.22869-9.18131-54.32277,0-54.32277,0s-8.3737,27.24644-8.22493,39.59442c.19128,15.876-22.57073,26.39628-22.57073,26.39628s-33.66482-8.03365-35.195-14.53708S347.87189,461.94665,350.54978,454.29555Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#575988"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M425.42271,451.04459a51.78109,51.78109,0,0,1-1.99625-27.16214l-75.74584,13.38942s1.09333,5.7244,2.329,14.30055a52.019,52.019,0,0,0,75.41307-.52783Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M438.3461,412.02325a52.02746,52.02746,0,0,1-104.03961,1.26243c-.01146-.4208-.01529-.84163-.01529-1.26243a52.03941,52.03941,0,0,1,29.166-46.752q2.34124-1.14192,4.80872-2.05815a52.39855,52.39855,0,0,1,26.798-2.48661.02867.02867,0,0,0,.01913.00383,51.98725,51.98725,0,0,1,43.14836,47.84613Q438.34611,410.28644,438.3461,412.02325Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#f7c4a7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.19321,364.43382a.767.767,0,0,1,.07268-.0459q-2.4675.91239-4.80871,2.05814a52.03939,52.03939,0,0,0-29.166,46.752c0,.42081.00383.84162.01527,1.26243a11.55728,11.55728,0,0,0,4.66719-1.12088c12.68553-5.91816,20.29454-24.03208,23.28228-36.664C363.32711,372.15379,364.35237,367.05818,368.19321,364.43382Z",
    transform: "translate(-37.66167 -65.36599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.01713,365.89517a51.59667,51.59667,0,0,0-12.93417-3.99,16.6899,16.6899,0,0,1,9.28845,5.834,23.7861,23.7861,0,0,1,2.84343,5.06875,52.16706,52.16706,0,0,0-43.75766.90674c3.267,7.1576,13.39325,11.06348,20.153,13.67634q11.10368,4.28655,22.46743,7.83854-3.34545-2.71994-6.6909-5.43227,7.55166,1.1993,15.10711,2.40243a26.16935,26.16935,0,0,0-1.05456-8.9055c2.87577,2.33234,6.73171,3.114,9.87244,5.09525,5.88753,3.71079,8.33586,10.87224,11.5455,17.04664a11.00993,11.00993,0,0,0,3.37413,4.31525A52.049,52.049,0,0,0,408.01713,365.89517Z",
    transform: "translate(-37.66167 -65.36599)"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M368.19321,363.259a.76683.76683,0,0,1,.07268-.04589q-2.4675.91237-4.80871,2.05813a52.0394,52.0394,0,0,0-29.166,46.752c0,.42081.00383.84163.01527,1.26244a11.5573,11.5573,0,0,0,4.66719-1.12089c12.68553-5.91815,20.29454-24.03208,23.28228-36.664C363.32711,370.97894,364.35237,365.88334,368.19321,363.259Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#632652"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M408.01713,364.72032a51.59665,51.59665,0,0,0-12.93417-3.99,16.68985,16.68985,0,0,1,9.28845,5.834,23.786,23.786,0,0,1,2.84343,5.06874,52.16706,52.16706,0,0,0-43.75766.90674c3.267,7.15761,13.39325,11.06348,20.153,13.67634q11.10368,4.28655,22.46743,7.83854-3.34545-2.71993-6.6909-5.43227,7.55166,1.1993,15.10711,2.40243a26.16941,26.16941,0,0,0-1.05456-8.9055c2.87577,2.33234,6.73171,3.114,9.87244,5.09525,5.88753,3.7108,8.33586,10.87224,11.5455,17.04664a11.00978,11.00978,0,0,0,3.37413,4.31525A52.049,52.049,0,0,0,408.01713,364.72032Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#632652"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M328.3616,403.443s53.55767-66.56453,115.53154,0l-5.35577-14.91963s-29.07416-42.46358-49.73212-33.28227-40.93336,15.68475-40.93336,15.68475Z",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M328.3616,402.26811s53.55767-66.56453,115.53154,0l-5.35577-14.91964s-29.07416-42.46358-49.73212-33.28226S347.87189,369.751,347.87189,369.751Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#e14b5a"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M284.3678,545.72614s-11.47664,30.60438,4.59066,58.14833-14.15453,39.02058-14.15453,39.02058",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M470.28942,518.1822s19.89285,25.24861,6.886,47.81935-12.24175,76.8935-12.24175,76.8935",
    transform: "translate(-37.66167 -65.36599)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M229.10859,600.0998H450.22528a18.36261,18.36261,0,0,1,18.36261,18.36261v0a0,0,0,0,1,0,0H210.746a0,0,0,0,1,0,0v0a18.36261,18.36261,0,0,1,18.36261-18.36261Z",
    fill: "#535461"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M262.37029,473.85672h154.5933a39,39,0,0,1,39,39V604.3079a0,0,0,0,1,0,0H223.37029a0,0,0,0,1,0,0V512.85672A39,39,0,0,1,262.37029,473.85672Z",
    fill: "#535461"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 339.47566,
    cy: 544.82063,
    r: 13.77197,
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M331.422,372.23282s52.6393-52.61064,109.41066-.95941",
    transform: "translate(-37.66167 -65.36599)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 411.18625,
    y: 303.5157,
    width: 5.28681,
    height: 29.95859,
    fill: "#6a5c99"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M404.13717,322.90067h0a18.2101,18.2101,0,0,1,18.2101,18.2101v1.17488a18.2101,18.2101,0,0,1-18.2101,18.2101h0a0,0,0,0,1,0,0V322.90067a0,0,0,0,1,0,0Z",
    fill: "#ffd037"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 400.61263,
    y: 321.1384,
    width: 8.22393,
    height: 41.11963,
    rx: 4.11196,
    fill: "#6a5c99"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 317.58062,
    y: 369.46911,
    width: 5.28681,
    height: 29.95859,
    transform: "translate(602.78638 703.53083) rotate(-180)",
    fill: "#6a5c99"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M311.70639,388.85408h0a18.2101,18.2101,0,0,1,18.2101,18.2101v1.17488a18.2101,18.2101,0,0,1-18.2101,18.2101h0a0,0,0,0,1,0,0V388.85408A0,0,0,0,1,311.70639,388.85408Z",
    transform: "translate(603.96123 749.93727) rotate(180)",
    fill: "#ffd037"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 325.21712,
    y: 387.09181,
    width: 8.22393,
    height: 41.11963,
    rx: 4.11196,
    transform: "translate(620.9965 749.93727) rotate(-180)",
    fill: "#6a5c99"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M448.2215,336.86c-7.1584-14.88425-22.74882-32.87968-56.35657-34.316l.00294-.041-.40346.01922-.02621-.00144-.00011.00269-11.90611.567.00125.05834c-33.38635,1.53678-48.90377,19.46191-56.03937,34.29875a77.15669,77.15669,0,0,0-7.38065,32.12242l4.11082-.10068,4.11081-.09436a69.96283,69.96283,0,0,1,6.69456-28.61968c9.06433-18.61455,25.73935-28.51613,49.56327-29.42939l-.00029-.00731,10.53042-.58287-.00011.00276c23.82392.91326,40.49893,10.81484,49.56327,29.42939a69.963,69.963,0,0,1,6.69456,28.61967l4.11081.09437,4.11082.10068A77.15663,77.15663,0,0,0,448.2215,336.86Z",
    transform: "translate(-37.66167 -65.36599)",
    fill: "#ffd037"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 37.61496,
    y: 618.7043,
    width: 560.7778,
    height: 150.56227,
    fill: "#d6d6e3"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 37.61496,
    y: 628.8383,
    width: 560.7778,
    height: 19.54414,
    opacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    y: 616.53273,
    width: 636.00409,
    height: 19.54414,
    fill: "#d6d6e3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M473.16576,633.2948s24,44,84,32,31,111,31,111-9.81716,58.67552-2.90858,58.33776",
    transform: "translate(-37.66167 -65.36599)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.4a530d1eee579b94774996e82a90c328.svg";
export { ForwardRef as ReactComponent };